import HTTP from '@/api/HTTP';
import genererPiecesJointes from '../piecesJointes/genererPiecesJointes';

export default async function AjoutPdfOpp(url) {
  const pdfOpp = (await HTTP.get(url, { responseType: 'blob' })).data;
  const fichierRecomPdf = new File([pdfOpp], 'Opportunite PDF.pdf', { type: pdfOpp.type });
  const res = await genererPiecesJointes([{ file: fichierRecomPdf, placeType: '' }]);
  return res;
}



// WEBPACK FOOTER //
// ./src/services/devis/ajoutPdfOpp.js